import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  Network,
  NftSchema,
  NftStandard,
  SortParam,
  PaginationParams,
  getURLParams,
  SortNftKey
} from '@mprolab/sdk'

export interface UserCollectedNftListParams extends PaginationParams {
  address: string
  contractAddress?: string
  standard?: NftStandard
  protocols?: string[]
  network?: Network
  _items?: boolean
  id?: number
  sort?: SortParam<SortNftKey>
  excludeCollections?: boolean
  showBlacklisted?: boolean
  createdBy?: string
}

export const nftApi = createApi({
  reducerPath: 'nft',
  baseQuery: fetchBaseQuery({ baseUrl: `${import.meta.env.VITE_NFT_SERVICE_API_URL}` }),
  tagTypes: ['Nft', 'SingleNft'],
  endpoints: (builder) => ({
    getUserNftsByAddress: builder.query<{ count: number; results: NftSchema[] }, UserCollectedNftListParams>({
      query: (params: UserCollectedNftListParams) => {
        const { address } = params
        const requestParams = getURLParams({ params, paramsToSkip: ['address'] })
        return {
          url: `user/${address}/tokens`,
          method: 'GET',
          params: requestParams
        }
      }
    })
  })
})

export const { useGetUserNftsByAddressQuery, useLazyGetUserNftsByAddressQuery } = nftApi
